import { createElement } from 'react';
import Markdown from 'react-markdown';
import { renderToStaticMarkup } from 'react-dom/server';

const renderStatic = renderToStaticMarkup as unknown as (
    element: ReturnType<typeof createElement>,
) => string;

export function markdownToHtml(markdown: string, allowedElements: string[]): string {
    const markdownElement = createElement(
        Markdown,
        {
            allowedElements: allowedElements,
        },
        markdown,
    );
    return renderStatic(markdownElement);
}
